import { Button, Container, Grid, Stack, TextField } from "@mui/material";
import {
  STRINGS_CATEGORIES,
  STRINGS_CREATE,
  STRINGS_PRODUCTS,
} from "../../../data/strings/Strings";
import { COLOR_BLACK, COLOR_LIGHT_GRAY } from "../../../data/colors/Colors";
import { AddRounded } from "@mui/icons-material";
import { ProductsViewModel } from "./ProductsViewModel";
import { ProductsListItemView } from "./productsListItemView/ProductsListItemView";
import {
  ROUTE_ENDPOINTS,
  ROUTE_NEW,
} from "../../../data/constant/RouteConstants";
import { CustomTextView } from "../../component/CustomTextView";
import { HeaderView } from "../../component/HeaderView";
import { EmptyView } from "../../component/EmptyView";
import { LoadingView } from "../../component/LoadingView";
import {
  provideEditDeliveryPriceUseCase,
  provideGetAllProductsUseCase,
  provideGetDeliveryPriceUseCase,
  provideGetPerProductReportUseCase,
} from "../../di/UseCasesModule";
import { ChooseStartEndDateView } from "../../component/ChooseStartEndDateView";
import { CustomTextField } from "../../component/CustomTextField";
import { MAIN_FONT_FAMILY } from "../../../data/constant/Constants";
import { NumericFormat } from "react-number-format";

export function ProductsView() {
  const viewModel = ProductsViewModel(
    provideGetAllProductsUseCase(),
    provideGetPerProductReportUseCase(),
    provideGetDeliveryPriceUseCase(),
    provideEditDeliveryPriceUseCase()
  );
  return (
    <Stack spacing={2}>
      <HeaderView
        title={STRINGS_PRODUCTS}
        isLayoutFullWidthInSmallerScreens={true}
        alignItems="start"
        layout={
          <Stack spacing={1} direction={"row"} justifyContent={"end"}>
            <Button
              href={`${ROUTE_ENDPOINTS.HOME_PRODUCTS}/${ROUTE_NEW}`}
              LinkComponent={"a"}
              variant="outlined"
              sx={{
                borderRadius: 22,
                borderColor: COLOR_BLACK,
                "&:hover": {
                  borderColor: COLOR_BLACK,
                },
              }}
            >
              <AddRounded fontSize="medium" sx={{ color: COLOR_BLACK }} />
              <CustomTextView
                text={STRINGS_CREATE}
                fontWeight="bold"
                fontSize={16}
                props={{ textTransform: "none" }}
                textColor={COLOR_BLACK}
              />
            </Button>
          </Stack>
        }
      />

      <ChooseStartEndDateView
        title="Download Products Report"
        onClicked={(startDate, endDate) => {
          viewModel.setCustomDate(startDate, endDate);
        }}
      />
      <Container maxWidth={false}>
        <Stack spacing={2}>
          <NumericFormat
            value={viewModel.deliveryPrice}
            thousandSeparator
            allowNegative={false}
            suffix={" QR"}
            placeholder="Delivery Price"
            customInput={TextField}
            label="Delivery Price"
            disabled={viewModel.deliveryPrice == undefined}
            onValueChange={(price) => {
              viewModel.handleDeliveryPriceChange(price.floatValue ?? 0);
            }}
            {...{
              InputProps: {
                sx: {
                  borderRadius: 44,
                  color: COLOR_BLACK,
                  fontFamily: MAIN_FONT_FAMILY,
                  fontWeight: "bold",
                  fontSize: 16,
                },
              },
              sx: {
                color: COLOR_BLACK,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: COLOR_LIGHT_GRAY,
                },
                "& .MuiOutlinedInput-root": {
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: COLOR_BLACK,
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: COLOR_BLACK,
                  },
                },
              },
            }}
          />
          {viewModel.isLoading ? (
            <LoadingView />
          ) : (
            <>
              {viewModel.products && (
                <>
                  {viewModel.products.length === 0 ? (
                    <EmptyView />
                  ) : (
                    <Grid container spacing={1.5} pb={3}>
                      {viewModel.products.map((product, index) => {
                        return (
                          <Grid
                            size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                            key={product._id}
                          >
                            <ProductsListItemView
                              product={product}
                              index={index}
                              href={`${ROUTE_ENDPOINTS.HOME_PRODUCTS}/${product._id}`}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
        </Stack>
      </Container>
    </Stack>
  );
}
